import React from 'react';
import { UserCheck } from 'lucide-react';
import Button from './Button';
import styles from './ProfessorWelcome.module.css';

function ProfileSetupSection({ completedSteps, onNavigateToProfile }) {
  const isComplete = completedSteps.size >= 2;

  return (
    <section className={`${styles.section} ${isComplete ? styles.sectionComplete : styles.sectionIncomplete}`}>
      {!isComplete ? (
        <>
          <h2 className={styles.sectionTitle}>Setup Your Faculty Profile</h2>
          <p className={styles.sectionDescription}>
            Complete your profile to start creating research positions and connecting with students.
          </p>
          <Button
            className="bg-[#061941] hover:bg-[#3C6E71] text-white"
            onClick={onNavigateToProfile}
          >
            Complete Profile
          </Button>
        </>
      ) : (
        <>
          <h2 className={`${styles.sectionTitle} ${styles.sectionTitleComplete}`}>
            <UserCheck className="w-6 h-6 mr-2" />
            Profile Setup Complete!
          </h2>
          <p className={styles.sectionDescription}>
            Excellent! Your faculty profile is ready. You can now create research positions and start recruiting students.
          </p>
        </>
      )}
    </section>
  );
}

export default ProfileSetupSection;